import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress, Checkbox, FormControlLabel } from '@mui/material';

const CompanyEditModal = ({ open, onClose, company, onSave }) => {
    const [formData, setFormData] = useState(company || {});
    const [loading, setLoading] = useState(false);
    const originalDataRef = useRef(company);

    useEffect(() => {
        setFormData(company || {});
        originalDataRef.current = company;
    }, [company]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSubmit = async () => {
        setLoading(true);

        const updatedData = { CompanyID: formData.CompanyID };
        for (const key in formData) {
            if (formData[key] !== originalDataRef.current[key]) {
                updatedData[key] = formData[key];
            }
        }
        await onSave(updatedData);
        setLoading(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{company ? 'Edit Company' : 'Add Company'}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Company Name"
                    name="CompanyName"
                    value={formData.CompanyName || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Company Type"
                    name="CompanyType"
                    value={formData.CompanyType || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Company Industry"
                    name="CompanyIndustry"
                    value={formData.CompanyIndustry || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Company Headquarters"
                    name="CompanyHeadquarters"
                    value={formData.CompanyHeadquarters || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Founded Year"
                    name="CompanyFoundedYear"
                    type="number"
                    value={formData.CompanyFoundedYear || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Revenue"
                    name="CompanyRevenue"
                    value={formData.CompanyRevenue || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Number of Employees"
                    name="CompanyNumberOfEmployees"
                    type="number"
                    value={formData.CompanyNumberOfEmployees || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Market Segment"
                    name="CompanyMarketSegment"
                    value={formData.CompanyMarketSegment || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name="CompanyGlobalPresence"
                            checked={formData.CompanyGlobalPresence || false}
                            onChange={handleChange}
                        />
                    }
                    label="Global Presence"
                />
                <TextField
                    label="Website URL"
                    name="CompanyWebsiteURL"
                    value={formData.CompanyWebsiteURL || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Contact Info"
                    name="CompanyContactInfo"
                    value={formData.CompanyContactInfo || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                < TextField
                    label="Description"
                    name="CompanyDescription"
                    value={formData.CompanyDescription || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={4}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name="CompanyIsConsultingCompany"
                            checked={formData.CompanyIsConsultingCompany || false}
                            onChange={handleChange}
                        />
                    }
                    label="Is Consulting Company"
                />
                {formData.CompanyIsConsultingCompany && (
                    <TextField
                        label="Consulting Company ID"
                        name="ConsultingCompanyID"
                        value={formData.ConsultingCompanyID || ''}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button onClick={handleSubmit} color="primary" disabled={loading}>
                    {loading ? (
                        <>
                            <CircularProgress size={20} style={{ marginRight: 8 }} color="inherit" />
                            Updating...
                        </>
                    ) : (
                        "Update"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CompanyEditModal;